import TodoList from "../todo-list/todo-list";

const Home = () => {
  return (
    <div className="home">
      <TodoList />
    </div>
  );
};

export default Home;
